/**
 * Publisher / embed query helpers.
 *
 * We support both:
 * - Normal web: window.location.search
 * - Embedded (mobile): window.__WORDHIT_EMBED_QUERY__ set by embed.js
 *
 * Embed params override location params when present.
 */
export function getAppSearchString() {
  if (typeof window === "undefined") return "";
  const loc = (window.location?.search || "").replace(/^\?/, "");
  const embed = (window.__WORDHIT_EMBED_QUERY__ || "").replace(/^\?/, "");
  if (!embed) return loc;
  const p = new URLSearchParams(loc);
  const e = new URLSearchParams(embed);
  e.forEach((value, key) => p.set(key, value));
  return p.toString();
}

/**
 * Reads pubID from query parameters and validates it as alphanumeric.
 * Returns null if missing/invalid.
 */
export function getPublisherId() {
  try {
    const urlParams = new URLSearchParams(getAppSearchString());
    const pubID = urlParams.get("pubID");

    if (!pubID) return null;

    const isValidFormat = /^[a-zA-Z0-9]+$/.test(pubID);
    if (isValidFormat) return pubID;

    console.warn(`Invalid pubID format in URL: "${pubID}". Ignoring.`);
    return null;
  } catch (e) {
    return null;
  }
}

